export enum ConsumerLoanLogType {
    Comment = 0,
    Event = 1,
    Change = 2,
    CustomerCommunication = 3,
    Document = 4
}
